import React from "react";
import { useParams, Link } from "react-router-dom";
import "./services.css";
import { Newnav } from "./Newnav";
import Proposal from "./images/inside_proposal.JPG";
import Wedding from "./images/inside_wedding.JPG";

const details = {
  proposal: {
    title: "Proposal/Engagement",
    intro:
      "We want your proposal photos to feel effortless, authentic, and true to who you are - capturing your connection in a way you'll love for years to come. We'll do everything we can to make you feel comfortable, confident, and genuinely happy throughout the experience.",
    img: Proposal,
    packages: [
      {
        name: "Package A",
        rate: "$300 (additional hour + $100)",
        items: [
          "1 hour session",
          "20 edited digital images",
          "1 year online gallery",
        ],
      },
      {
        name: "Package B",
        rate: "$350 (additional hour + $100)",
        items: [
          "1.5 hour session",
          "30 edited digital images",
          "1 year online gallery",
        ],
      },
    ],
    note: "Additional photos can be purchased at extra cost",
  },
  // engagements: {
  //   title: "Engagements",
  //   intro: "Engagement session details. Please reach out to inquire.",
  //   img: Engagements,
  //   packages: [
  //     {
  //       name: "Package A",
  //       rate: "$300 (additional hour + $100)",
  //       items: [
  //         "1 hour session",
  //         "20 edited digital images",
  //         "1 year online gallery",
  //       ],
  //     },
  //     {
  //       name: "Package B",
  //       rate: "$350 (additional hour + $100)",
  //       items: [
  //         "1.5 hour session",
  //         "30 edited digital images",
  //         "1 year online gallery",
  //       ],
  //     },
  //   ],
  //   note: "Additional photos can be purchased at extra cost",
  // },
  wedding: {
    title: "Wedding",
    img: Wedding,
    intro:
      "Your wedding day will be filled with moments you'll never want to forget, and we're here to preserve them with care and intention. Our goal is to capture every genuine laugh, happy tear, and meaningful detail while creating an experience that allows you to relax, be present, and truly enjoy every moment.",
    packages: [
      {
        name: "Package A",
        rate: "Starting at $3000 (additional charges per hour apply)",
        items: ["Up to 400 edited digital images", "5 hours of coverage"],
      },
      {
        name: "Package B",
        rate: "Starting at $4000 (additional charges per hour apply)",
        items: ["Up to 600 edited digital images", "7 hours of coverage"],
      },
      {
        name: "Package C",
        rate: "Starting at $5000 (additional charges per hour apply)",
        items: ["Up to 800 edited digital images", "10 hours of coverage"],
      },
    ],
    note: "Additional photos can be purchased at extra cost",
  },
};

const ServiceDetail = () => {
  const { slug } = useParams();
  const data = details[slug] || {
    title: slug,
    intro: "Details not found",
    packages: [],
  };

  return (
    <div className="services-page">
      <Newnav />
      <div className="service-detail">
        <div className="service-inside-media">
          <img src={data.img} alt={data.title} />
        </div>

        <div className="detail-inner">
          <h1>{data.title}</h1>
          <p className="detail-intro">{data.intro}</p>

          {data.packages && data.packages.length > 0 && (
            <div className="packages">
              {data.packages.map((p) => (
                <div className="package" key={p.name}>
                  <h3>{p.name}</h3>
                  <p className="rate">Rate: {p.rate}</p>
                  <ul>
                    {p.items.map((it) => (
                      <li key={it}>{it}</li>
                    ))}
                  </ul>
                  <br />
                </div>
              ))}
            </div>
          )}

          {data.note && <p className="note">{data.note}</p>}

          <div className="detail-actions">
            <Link to="/contact-us" className="inquire-button">
              Inquire
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceDetail;
